import React, { Suspense } from "react";
import AppBar from "@material-ui/core/AppBar";
import { Toolbar, IconButton } from "@material-ui/core";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { withStyles, withTheme } from "@material-ui/core/styles";
import { Redirect, withRouter } from "react-router-dom";
import { compose } from "recompose";
import Menu from "@material-ui/core/Menu";
import { observer, inject } from "mobx-react";
import { withUserProfile } from "../../../userProfile/userProfileContext";
import { getDataWithQueryString, postData } from "../../../api/componentAPIs";
import Events from "../../../utilities/EventEmitter";
import { withSnackbar } from "notistack";
import appConstants from "../../../appConstants";
import MESSAGES from "../../../appMessages";
import MoreVert from "@material-ui/icons/MoreVert";
import formatDate from "date-fns/format";
import Tooltip from "../../common/StyledToolTip";
import { format, isAfter } from "date-fns";
import { AppLoading } from "../../../loaders/loaders";
import styles from "../headerStyles";
import ModuleSwitcher from "../ModuleSwitcher";
import { groupBy, sortBy } from "lodash";
import RightNavigationMenu from "./rightNavigationMenu";
import withWidth from "@material-ui/core/withWidth";
import AnimationRenderer from "../../animations/animationRenderer";
import * as PrintAnimation from "../../animations/json/Printing.json";
import CustomSnackbarRenderer from "../../customSnackbars/customSnackbarRenderer";
import { trackEvent } from "../../common/AppInsightsEventTracking";
import { convertDateTimeToTimeString } from "../../dataGrid/gridUtilities";
import ShipmentSelection from "./components/ShipmentSelection";
import { withAppConfig } from "../../../appConfigContext";
import PreferredRouteWarningDialog from "../Dialogs/PreferredRouteWarningDialog/index";
import EditCustomer from "../../modules/CustomerManagement/EditCustomer";
import ParameterListener from "../Parameters";
import ShipmentSelectionMenu from "./components/ShipmentSelectionMenu";
import { getShipmentsDataByShipmentType, getStopsDataByType } from "../../modules/utils";
import AddNewShipmentsOverlay from "../../modules/IBPlanning/RoutesView/AddNewShipmentsOverlay";
import NewShipmentsFeedbackPanel from "../../modules/IBPlanning/RoutesView/NewShipmentsFeedbackPanel";

const AboutRMAXDialog = React.lazy(() => import("../Dialogs/AboutRMAXDialog"));
const PublishDialog = React.lazy(() => import("../Dialogs/PublishDialog"));
const ETLProgressDialog = React.lazy(() =>
  import("../Dialogs/ETLProgressDialog")
);
const TerminalSelect = React.lazy(() => import("../terminalSelect"));
const DynamicRoutingDialog = React.lazy(() =>
  import("../Dialogs/DynamicRoutingDialog")
);
const DynamicRoutingFeedback = React.lazy(() =>
  import("../Dialogs/DynamicRoutingFeedback")
);

@inject("IBPlanningStore", "CommonStore")
@observer
class IbplanningHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTabValue:
        this.props.path && this.props.path.params.moduleName
          ? this.props.path.url.toLowerCase()
          : false,
      isDataRefreshProgress: false,
      isETLRunningForFirstPush: false,
      currentPlanDate: null,
      isDialogOpen: false,
      title: "",
      dynamicRoutingProgressValue: 0,
      isDynamicRoutingInProgress: false,
      isDynamicRoutingCompleted: false,
      featureFlags: this.props.featureFlags ?? [],
      openDynamicRoutingFeedback: false,
      dynamicRoutingOutput: {
        affectedRoutes: [],
        lastWaveRoutes: [],
        extraTrailerRoutes: [],
      },
      preferredRouteWarningData: null,
      editCustomer: null,
      showNotificationPanel : false,
      showNewShipmentsNotification: false,
      newShipmentsUnreadCount : 0
      // isOptimizationRunning: false
    };
    this.tabValues = [
      appConstants.NAV_URLS.IBPLANNING_SHIPMENTS,
      appConstants.NAV_URLS.IBPLANNING_ROUTES,
      appConstants.NAV_URLS.IBPLANNING_CUSTOMERS,
    ];
    this.routesToPrint = [];
    this.printSnackbarkey = null;
    this.userProfileData = {
      terminal: this.props.userData.userProfile.terminal.code,
      userName: this.props.userData.userProfile.userName,
      planDate: this.props.userData.userProfile.planDate,
    };
  }
  componentDidMount() {
    const { IBPlanningStore } = this.props;
    !IBPlanningStore.staticClientData && this.populateClientCodesData();
    Events.on("RefreshIBStore", this.updateIBPlanningStore);
    Events.on("RoutingStatus", this.checkAndNotifyRoutingStatus);
    Events.on("RedirectToPage", this.handleChange);
    Events.on("RoutePublishCompleted", this.checkAndNotifyPublishStatus);
    Events.on("ETLProgress", this.checkAndNotifyETLProgress);
    Events.on("RefreshKPI", this.getKPIGoals);
    Events.on("PublishNPrint", this.printNPublish);
    Events.on("OpenEditCustomerDialog", this.openCustomerDialog);
    Events.on("NewShipmentsDetected", this.handleNewShipmentsNotification);
    this.updateIBPlanningStore();
    this.getNewShipmentsData();
    const newShipments = JSON.parse(sessionStorage.getItem("newShipments"));
    if (
      newShipments &&
      newShipments.scenarioID &&
      this.props.userData.userProfile.scenarioID !== newShipments.scenarioID
    ) {
      const newShipmentsData = {
        scenarioID: this.props.userData.userProfile.scenarioID,
        data: [],
      };
      this.props.IBPlanningStore.updateNewShipments(newShipmentsData);
    }
  }
  componentWillUnmount() {
    Events.removeListener("RefreshIBStore", this.updateIBPlanningStore);
    Events.removeListener("RoutingStatus", this.checkAndNotifyRoutingStatus);
    Events.removeListener("RedirectToPage", this.handleChange);
    Events.removeListener(
      "RoutePublishCompleted",
      this.checkAndNotifyPublishStatus
    );
    Events.removeListener("ETLProgress", this.checkAndNotifyETLProgress);
    Events.removeListener("RefreshKPI", this.getKPIGoals);
    Events.removeListener("PublishNPrint", this.printNPublish);
    Events.removeListener("OpenEditCustomerDialog", this.openCustomerDialog);
    Events.off("NewShipmentsDetected", this.handleNewShipmentsNotification);
  }

  componentDidUpdate(prevProps) {
    if (this.props.theme.themeName !== prevProps.theme.themeName) {
      if (this.props.IBPlanningStore.routesList.length > 0) {
        this.props.IBPlanningStore.addRoutes(
          this.props.IBPlanningStore.routesList,
          this.props.theme.routeMapColorPalette.IconsColors
        );
      }
    }
    if (
      this.props.userData.userProfile.terminal.id !==
        prevProps.userData.userProfile.terminal.id ||
      this.props.userData.userProfile.scenarioID !==
        prevProps.userData.userProfile.scenarioID
    ) {
      const newShipmentsData = {
        scenarioID: this.props.userData.userProfile.scenarioID,
        data: [],
      };
      this.closeCustomerDialog();
      this.props.IBPlanningStore.updateNewShipments(newShipmentsData);
      this.getNewShipmentsData();
      this.resetNotificationCount()
    }
    if (this.props.width !== prevProps.width) {
      this.setState({ terminalanchorEl: null });
    }
    if (this.props.featureFlags !== prevProps.featureFlags) {
      this.setState({
        featureFlags: this.props.featureFlags,
      });
    }
  }

  checkAndNotifyRoutingStatus = (
    scenarioId,
    isSuccess,
    affectedRoutes = [],
    lastWaveRoutes = [],
    extraTrailerRoutes = [],
    dynamicRoutingProgressValue = 0
  ) => {
    if (
      scenarioId &&
      this.props.userData.userProfile.scenarioID === scenarioId
    ) {
      if (dynamicRoutingProgressValue) {
        !this.state.isDialogOpen && this.shouldDialogOpen("dynamicRouting");
        this.setState({
          isDynamicRoutingInProgress: true,
          dynamicRoutingProgressValue,
        });
      } else {
        this.props.CommonStore.updateIsOptimizationRunningFlag(false);
        if (!isSuccess) {
          this.closeDialog();
          this.props.enqueueSnackbar(`Optimization failed`, {
            variant: "error",
          });
        } else {
          this.setState({
            isDynamicRoutingCompleted: isSuccess,
            openDynamicRoutingFeedback: true,
            dynamicRoutingOutput: {
              affectedRoutes,
              lastWaveRoutes,
              extraTrailerRoutes,
            },
          });
        }
        this.updateIBPlanningStore(false, affectedRoutes);
      }
    }
  };
  checkAndNotifyPublishStatus = (scenarioId, terminalCode, isSuccess) => {
    if (
      scenarioId &&
      this.props.userData.userProfile.scenarioID === scenarioId
    ) {
      if (this.printSnackbarkey) {
        this.props.closeSnackbar(this.printSnackbarkey);
      }
      if (!isSuccess) {
        this.props.enqueueSnackbar(`${terminalCode} routes publish failed`, {
          variant: "error",
        });
      } else {
        if (this.props.IBPlanningStore.isPublishInProgress) {
          this.printLoadingManifest();
        } else {
          this.props.enqueueSnackbar(`${terminalCode} routes published`, {
            variant: "success",
            persist: true,
          });
        }
      }
      this.props.IBPlanningStore.setIsPublishInProgress(false);
      this.routesToPrint = [];
    }
  };

  getPlanDateConditionBasedOnFlag = (planDate) => {
    const {
      userData: { userProfile },
      configJSON,
    } = this.props;
    return configJSON?.showDateRangeInShipmentSelection
      ? true : (!userProfile.planDate || isAfter(planDate, userProfile.planDate))
  };

  checkAndNotifyETLProgress = (
    etlStatus,
    scenarioId,
    terminalCode,
    isSuccess,
    isFirstPush,
    planDate
  ) => {
    const {
      userData: { userProfile },
    } = this.props;
    if (etlStatus === "started") {
      if (scenarioId !== null) {
        //ETL started for Incremental Push
        //Commenting below line to reduce the notification clutter
        //this.props.enqueueSnackbar(`Data refresh is in progress for ${terminalCode}`, {variant: "info"})
        this.setState({
          isDataRefreshProgress: true,
        });
      } else {
        if (isFirstPush && this.getPlanDateConditionBasedOnFlag(planDate)) {
          this.setState({
            isETLRunningForFirstPush: true,
            isDataRefreshProgress: true,
            currentPlanDate: formatDate(planDate, "MM-dd"),
            isDialogOpen: false,
          });
        }
      }
    } else {
      //ETL completed
      if (scenarioId !== null && userProfile.scenarioID === scenarioId) {
        if (!isSuccess) {
          this.props.enqueueSnackbar(
            `Data refresh failed for ${terminalCode}`,
            { variant: "info" }
          );
        } else {
          this.updateIBPlanningStore(
            false,
            this.props.IBPlanningStore.selectedRouteNameList,
            this.props.IBPlanningStore.selectedShipmentIDList,
            true
          );
        }
        this.setState({
          isDataRefreshProgress: false,
          isETLRunningForFirstPush: false,
        });
      } else if (isFirstPush && this.getPlanDateConditionBasedOnFlag(planDate)) {
        //We don't have ScenarioID so it might be
        if (isSuccess) {
          this.props.enqueueSnackbar(
            `Redirecting as new data available for terminal ${terminalCode}`,
            { variant: "success" }
          );
          Events.emit("RefreshUserInfo");
        } else {
          this.props.enqueueSnackbar(
            `Data load for ${this.state.currentPlanDate} failed`,
            { variant: "error" }
          );
        }
        this.setState({
          isDataRefreshProgress: false,
          isETLRunningForFirstPush: false,
          currentPlanDate: null,
        });
      } else if (!isFirstPush && scenarioId === null) {
        this.props.enqueueSnackbar(`Data refresh failed for ${terminalCode}`, {
          variant: "error",
        });
        this.setState({
          isDataRefreshProgress: false,
          isETLRunningForFirstPush: false,
          currentPlanDate: null,
        });
      }
    }
  };

  updateIBPlanningStore = (
    showNotification = false,
    selectedRoutesList = [],
    selectedShipmentsList = [],
    getNewBills = false
  ) => {
    const { scenarioID, planDate } = this.props.userData.userProfile;
    this.props.IBPlanningStore.updateDataRefreshProgress(true);
    const routesPromise = getDataWithQueryString(
      "RoutesGrid",
      `scenarioId=${scenarioID}`
    );
    const stopsPromise = getDataWithQueryString(
      "StopsGrid",
      `scenarioId=${scenarioID}`
    );
    
    const shipmentPromise = getDataWithQueryString(
      "ShipmentsGrid",
      `scenarioId=${scenarioID}&planDate=${planDate}`
    ).then((response) => {
      if (response.status === 200) {
        this.props.IBPlanningStore.addShipments(
          getShipmentsDataByShipmentType(response.data)
        );

        selectedShipmentsList &&
          this.props.IBPlanningStore.updateSelectedShipments(
            selectedShipmentsList
          );
      }
      return response;
    });
    const newBillsPromise = getNewBills
      ? getDataWithQueryString("GetNewShipments", `scenarioId=${scenarioID}`)
      : [];

    // If one of route/ routesStop get bit delayed the data on UI will be out of sync between route and routeStops causing multiple rerenders of Map
    //, which causes multiple calls to mapbox directions API
    Promise.all([
      routesPromise,
      stopsPromise,
      shipmentPromise,
      newBillsPromise,
    ]).then(
      ([routes, stops, shipments, newBills]) => {
        if (
          routes.status === 200 &&
          stops.status === 200 &&
          shipments.status === 200
        ) {
          const newShipmentsData = {
            scenarioID,
            data: getNewBills ? newBills.data : [],
          };
          //Update data sources in IBPlanning Store with new data available
          const updatedDataSources = {
            routesData: routes.data,
            stopsData: getStopsDataByType(stops.data),
            newShipments: newShipmentsData,
            iconsColor: this.props.theme.routeMapColorPalette.IconsColors,
            planDate,
            getNewBills,
          };
          this.props.IBPlanningStore.refreshDataSources(updatedDataSources);
          selectedRoutesList &&
            this.props.IBPlanningStore.updateSelectedRoutes(selectedRoutesList);
          showNotification &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.DATA_REFRESHED, {
              variant: "info",
            });

          //For new bills added notification snackbar
          if (getNewBills) {
            const routesAffected = groupBy(
              newBills.data.filter(
                (newShipments) =>
                  newShipments.routeName !== appConstants.UNRTD_ROUTENAME
              ),
              "routeName"
            );
            const affectedRoutesLength = Object.keys(routesAffected).length;
            if (newBills.data.length || affectedRoutesLength)
              this.props.enqueueSnackbar(
                `${affectedRoutesLength} Routes got affected. ${newBills.data.length} Shipments got added.`,
                { variant: "success" }
              );
          }
        }
        this.props.IBPlanningStore.updateDataRefreshProgress(false);
        this.props.IBPlanningStore.setdisableStoreUpdate(false);
      },
      (error) => {
        this.props.IBPlanningStore.setdisableStoreUpdate(false);
        this.props.IBPlanningStore.updateDataRefreshProgress(false);
      }
    );

    getDataWithQueryString("GetAnchorPoints", `scenarioId=${scenarioID}`).then(
      (response) => {
        if (response.status === 200) {
          this.props.CommonStore.updateAnchorPointsData(response.data);
        } else {
          this.props.CommonStore.updateAnchorPointsData([]);
        }
      }
    );

    getDataWithQueryString("GetAllTrailers", `scenarioId=${scenarioID}`).then(
      (response) => {
        if (response.status === 200) {
          this.props.CommonStore.updateTrailersData(response.data);
        }
      }
    );

    getDataWithQueryString("GetAllTractors", `scenarioId=${scenarioID}`).then(
      (response) => {
        if (response.status === 200) {
          this.props.CommonStore.updateTractorsData(response.data);
        }
      }
    );

    getDataWithQueryString("GetWaves", `scenarioId=${scenarioID}`).then(
      (response) => {
        if (response.status === 200) {
          this.props.CommonStore.updateWaveData(response.data);
        }
      }
    );

     getDataWithQueryString("GetAllDropYard").then((response) => {
      if (response.status === 200) {
        this.props.CommonStore.updateDropYardList(response.data);
      } else {
        this.props.CommonStore.updateDropYardList([]);
      }
    });

    this.getKPIGoals();
  };

  getKPIGoals = () => {
    const { scenarioID } = this.props.userData.userProfile;
    getDataWithQueryString("IBKPIs", `scenarioId=${scenarioID}`).then(
      (response) => {
        if (response && response.status === 200) {
          this.props.IBPlanningStore.updateKPIData(response.data);
        } else {
          this.props.IBPlanningStore.updateKPIData([]);
        }
      }
    );
  };

  populateClientCodesData=()=>{
    getDataWithQueryString("GetClientCodes").then(
      (response) => {
        if (response && response.status === 200) {
          this.props.IBPlanningStore.setStaticClientData(response.data);
        } else {
          this.props.IBPlanningStore.setStaticClientData(null);
        }
      }
    );
  }

  handleChange = (event, value) => {
    this.setState({
      currentTabValue: value,
    });
    this.closeCustomerDialog();
  };

  handleTerminalChange = (event) => {
    sessionStorage.setItem("selectedTerminal", event.target.value);
    this.props.glEventHub &&
      this.props.glEventHub.emit("DispatchEvents", "RefreshUserInfo", [
        event.target.value,
        `Switched to terminal ${event.target.labels[0].innerText}`,
      ]);
    this.props.IBPlanningStore.updateSelectedRoutes([]);
    this.props.IBPlanningStore.updateSelectedShipments([]);
    this.setState({
      terminalanchorEl: null,
      mainMenuAnchor: null,
    });
  };

  handleTerminalClick = (event) => {
    this.setState({ terminalanchorEl: event.currentTarget });
  };

  openModuleSwitcher = (event) => {
    this.setState({ moduleSwitcherAnchor: event.currentTarget });
  };

  handleTerminalClose = () => {
    this.setState({ terminalanchorEl: null });
  };

  onModuleSwitcherClose = () => {
    this.setState({ moduleSwitcherAnchor: null });
  };
  shouldDialogOpen = (title, open = true) => {
    //resetting dynamic routing states to their initial values on mounting of the dynamic routing dialog
    if (title === "dynamicRouting") {
      this.resetDynamicRoutingValues();
    }

    this.setState({
      title: title,
      isDialogOpen: open,
    });
  };

  resetDynamicRoutingValues = () => {
    this.setState({
      isDynamicRoutingInProgress: false,
      isDynamicRoutingCompleted: false,
      dynamicRoutingProgressValue: 0,
    });
  };

  closeDialog = () => {
    this.setState({
      isDialogOpen: false,
    });
  };

  onCloseEditCustomer  = ({updateSuccess}) => {
    if (updateSuccess){
      this.updateIBPlanningStore(
        false,
        this.props.IBPlanningStore.selectedRouteNameList,
        this.props.IBPlanningStore.selectedShipmentIDList
      );
    }
    this.closeDialog();
  }

  getDialogComponent = (title) => {
    switch (title) {
      case "aboutRMAX":
        return (
          <AboutRMAXDialog
            show={this.state.isDialogOpen}
            onClose={() => this.closeDialog()}
          />
        );
      case "publish":
        return (
          <PublishDialog
            show={this.state.isDialogOpen}
            onClose={() => this.closeDialog()}
            publish={() => this.publishRoutes()}
          />
        );
      case "dynamicRouting":
        return (
          <DynamicRoutingDialog
            show={this.state.isDialogOpen}
            onClose={this.closeDialog}
            data={this.getDynamicRoutingData()}
            triggerDynamicRouting={this.triggerDynamicRouting}
            dynamicRoutingProgressValue={this.state.dynamicRoutingProgressValue}
            inProgress={this.state.isDynamicRoutingInProgress}
            isCompleted={this.state.isDynamicRoutingCompleted}
            terminalId={this.props.userData.userProfile.terminal.id}
          />
        );
      case "PreferredRouteWarning":
        return (
          <PreferredRouteWarningDialog
            show={this.state.isDialogOpen}
            onClose={this.closeDialog}
            preferredRouteWarningData={this.state.preferredRouteWarningData}
            openCustomerDialog={this.openCustomerDialog}
          />
        );
      case "EditCustomer":
        return (
          <EditCustomer
            customerCode={this.state.editCustomer?.customerCode}
            detail={this.state.editCustomer?.detail}
            handleClose={this.closeDialog}
            open={true}
            glEventHub={this.props.glEventHub}
          />
        );
      default:
        return "";
    }
  };

  closeCustomerDialog=()=>{
    if (this.state.editCustomer) {
      this.setState({ editCustomer: null });
      this.shouldDialogOpen('EditCustomer', false)
    }
  }

  openCustomerDialog = (customerCode, detail) => {
    if(!customerCode){
      return null
    }

    this.setState(
      {
        editCustomer: { customerCode, detail },
      },
      () => this.shouldDialogOpen("EditCustomer", true)
    );

  }

  getDynamicRoutingData = () => {
    const dynamicRoutingData = {
      totalRoutes: 0,
      totalLockedRoutes: 0,
      totalUnlockedRoutes: 0,
      totalPartialLockedRoutes: 0,
      totalTrapRoutes: 0,
      selectedRoutes: [],
      trailersData: [],
      tractorsData: [],
      shipmentDetails: {
        Pros: 0,
        Stops: 0,
        HU: 0,
        "LG Pros": 0,
        PSE: 0,
        Priority: 0,
        Weight: 0,
        "Pup Pros": 0,
      },
      optimizationConstraints: {
        expectedRouteCount: null,
        liftgateTrailerCount: null,
        maxStopsPerRouteCount: 0,
        maxLiftgateTrailerAvailable: 0,
        lastWaveCutOff: "",
        dockCutOffTime: ""
      },
    };
    this.props.IBPlanningStore.routesList.map((route) => {
      if (
        route.routeName !== appConstants.UNRTD_ROUTENAME &&
        this.props.IBPlanningStore.selectedRouteNameList.includes(
          route.routeName
        )
      ) {
        dynamicRoutingData.totalRoutes++;
        dynamicRoutingData.totalLockedRoutes +=
          route.status === appConstants.routeLockStates.LOCK.value ? 1 : 0;
        dynamicRoutingData.totalUnlockedRoutes +=
          route.status === appConstants.routeLockStates.UNLOCK.value ? 1 : 0;
        dynamicRoutingData.totalPartialLockedRoutes +=
          route.status === appConstants.routeLockStates.PARTIAL_LOCK.value
            ? 1
            : 0;
        dynamicRoutingData.totalTrapRoutes += route.isTrapRoute ? 1 : 0;
        dynamicRoutingData.selectedRoutes.push(route.routeName);
        dynamicRoutingData.shipmentDetails.Pros += route.prosCount || 0;
        dynamicRoutingData.shipmentDetails.Stops +=
          route.deliveryStopsCount || 0;
        dynamicRoutingData.shipmentDetails.HU += route.totalHu || 0;
        dynamicRoutingData.shipmentDetails["LG Pros"] += route.lgProCount || 0;
        dynamicRoutingData.shipmentDetails.PSE += route.totalPse || 0;
        dynamicRoutingData.shipmentDetails.Priority +=
          route.priorityProCount || 0;
        dynamicRoutingData.shipmentDetails.Weight += route.totalWeight || 0;
      }
    });

    dynamicRoutingData.error =
      this.getDynamicRoutingDataError(dynamicRoutingData);
    dynamicRoutingData.shipmentDetails.Weight += " lbs";

    this.props.IBPlanningStore.filteredRouteShipments.map((shipment) => {
      const equipments = shipment.eqpmtPref && shipment.eqpmtPref.split(", ");
      if (
        equipments &&
        equipments.length &&
        (equipments.includes("Pup") || equipments.includes("PupLG"))
      ) {
        dynamicRoutingData.shipmentDetails["Pup Pros"] += 1;
      }
    });

    const maxNumberOfStopsPerRoute = this.props.CommonStore.parametersData.find(
      (param) => param.parameterName === "MaxNumberOfStopsPerRoute"
    );
    let waveCutOffTime = this.props.CommonStore.wavesData[0].ibetaCutOffTime;
    this.props.CommonStore.wavesData.map((wave) => {
      waveCutOffTime =
        convertDateTimeToTimeString(waveCutOffTime) <
        convertDateTimeToTimeString(wave.ibetaCutOffTime)
          ? wave.ibetaCutOffTime
          : waveCutOffTime;
    });

    dynamicRoutingData.optimizationConstraints.maxStopsPerRouteCount =
      maxNumberOfStopsPerRoute
        ? maxNumberOfStopsPerRoute.scenarioValue ||
          maxNumberOfStopsPerRoute.defaultValue
        : 0;
    dynamicRoutingData.optimizationConstraints.lastWaveCutOff =
      convertDateTimeToTimeString(waveCutOffTime);
    dynamicRoutingData.optimizationConstraints.dockCutOffTime = this.props.userData.userProfile.terminal.dockCutOffTime

    dynamicRoutingData.trailersData =
      this.props.CommonStore.trailersData.slice();
    dynamicRoutingData.tractorsData =
      this.props.CommonStore.tractorsData.slice();
    return dynamicRoutingData;
  };

  //To map trailerName properly
  getTrailerLabel = (value) => {
    const trailerName = value.toLowerCase();
    switch (trailerName) {
      case "pup":
        return "Pup";
      case "puplg":
        return "PupLG";
      case "van":
        return "Van";
      case "vanlg":
        return "VanLG";
      case "straighttruck":
        return "Bob";
      case "straighttrucklg":
        return "BobLG";
      default:
        return "";
    }
  };

  getDynamicRoutingDataError = (data) => {
    if (data.totalRoutes === data.totalTrapRoutes) {
      return "Trap routes cannot be optimized";
    } else if (data.totalLockedRoutes) {
      return "Locked routes cannot be optimized";
    }
  };
  publishRoutes = (showNotification = true) => {
    const userProfile = this.props.userData.userProfile;
    postData("PublishRoutes", {
      scenarioId: userProfile.scenarioID,
      startDate: userProfile.startDate,
      planDate: userProfile.planDate,
    }).then(
      (response) => {
        if (response && response.status === 200) {
          showNotification &&
            this.props.enqueueSnackbar(MESSAGES.ROUTE_PUBLISH.START_SUCCESS, {
              variant: "success",
            });
        } else {
          this.props.enqueueSnackbar(MESSAGES.ROUTE_PUBLISH.START_FAILURE, {
            variant: "error",
          });
        }
      },
      (error) => {
        this.props.enqueueSnackbar(MESSAGES.ROUTE_PUBLISH.START_FAILURE, {
          variant: "error",
        });
      }
    );
    this.closeDialog();

    trackEvent("PublishRoutes", userProfile);
  };

  triggerDynamicRouting = (configData) => {
    this.props.CommonStore.updateIsOptimizationRunningFlag(true);

    const reqObj = {
      terminal: this.props.userData.userProfile.terminal.code,
      scenarioId: this.props.userData.userProfile.scenarioID,
    };
    this.setState({
      isDynamicRoutingInProgress: true,
    });
    postData(`TriggerDynamicRouting`, { ...configData, ...reqObj }).then(
      (response) => {
        if (response && Math.trunc(response.status / 100) === 2) {
          return;
        } else{
          this.resetDynamicRoutingValues();
        }

          if (
            response?.response?.status === 409 &&
            response?.response?.data?.error?.message
          ) {
            try {
              const errorMsg = JSON.parse(response.response.data.error.message);
              if (errorMsg?.length) {
                this.setState(
                  {
                    preferredRouteWarningData: JSON.parse(
                      response.response.data.error.message
                    ),
                  },
                  () => this.shouldDialogOpen("PreferredRouteWarning", true)
                );

                this.props.CommonStore.updateIsOptimizationRunningFlag(false);
                return;
              }
            } catch (ex) {
              console.log("Unable to parse json")
            }
           
          } 
          this.closeDialog();
          this.props.enqueueSnackbar(
            MESSAGES.ROUTE_OPTIMIZATION.START_FAILURE +
              ":" +
              response?.response?.data?.error?.message,
            { variant: "error" }
          );
          this.props.CommonStore.updateIsOptimizationRunningFlag(false);
        }
      ,
      (error) => {
        console.log(MESSAGES.ROUTE_OPTIMIZATION.START_FAILURE, error);
        this.props.enqueueSnackbar(MESSAGES.ROUTE_OPTIMIZATION.START_FAILURE, {
          variant: "error",
        });
        this.closeDialog();
        this.props.CommonStore.updateIsOptimizationRunningFlag(false);
        this.resetDynamicRoutingValues();
      }
    );

    const userProfile = this.props.userData.userProfile;
    trackEvent("DynamicRouting", userProfile, { config: configData });
  };

  getTerminalMenuData = () => {
    const groupDataByRegion = groupBy(
      this.props.userData.userProfile.terminals,
      "terminalRegion"
    );
    const terminalData = Object.keys(groupDataByRegion).sort();

    let options = terminalData.map((region) => ({
      region: region,
      regionTerminals: sortBy(groupDataByRegion[region], "terminalCode"),
    }));
    let activeTerminalData = this.props.userData.userProfile.terminals.find(
      (terminal) =>
        terminal.terminalCode === this.props.userData.userProfile.terminal.code
    );

    return { options, activeTerminalData };
  };

  openMainMenu = (event) => {
    this.setState({ mainMenuAnchor: event.currentTarget });
  };

  closeMainMenu = () => {
    this.setState({ mainMenuAnchor: null });
  };

  printNPublish = () => {
    const selectedRoutesCount =
      this.props.IBPlanningStore.selectedRouteNameList.length;
    if (selectedRoutesCount) {
      this.printSnackbarkey = this.props.enqueueSnackbar(
        `Loading manifest printing is in progress`,
        {
          variant: "info",
          persist: true,
          content: (key) => (
            <CustomSnackbarRenderer
              animation={
                <AnimationRenderer
                  animationJSON={PrintAnimation}
                  dimension="30px"
                />
              }
              snackbarLabel="Printing is in progress"
              id={key}
            />
          ),
        }
      );
      this.props.IBPlanningStore.setIsPublishInProgress(true);
      const selectedRoutesToPrint = [
        ...this.props.IBPlanningStore.selectedRouteNameList,
      ];
      selectedRoutesToPrint.forEach((routeName) => {
        const routeNameAndWave = routeName.split("_");
        this.routesToPrint.push({
          routeName: routeNameAndWave[0],
          wave: routeNameAndWave.length > 1 ? routeNameAndWave[1] : 0,
        });
      });
      //Initiate a publish
      this.publishRoutes(false);
    } else {
      this.props.enqueueSnackbar(MESSAGES.COMMON.NO_ROUTE_SELECTED, {
        variant: "info",
      });
    }
  };
  printLoadingManifest = () => {
    if (this.routesToPrint.length > 0) {
      postData("PrintLoadingManifest", {
        scenarioId: this.props.userData.userProfile.scenarioID,
        plandate: this.props.userData.userProfile.planDate,
        routes: this.routesToPrint,
      }).then(
        (response) => {
          if (Math.trunc(response.status / 100) === 2) {
            this.props.enqueueSnackbar(`Printing completed`, {
              variant: "success",
              persist: false,
            });
          } else {
            this.props.enqueueSnackbar(
              `Error while printing loading manifest`,
              { variant: "error", persist: false }
            );
          }
        },
        (error) => {
          this.props.enqueueSnackbar(`Error while printing loading manifest`, {
            variant: "error",
            persist: false,
          });
        }
      );

      const userProfile = this.props.userData.userProfile;
      trackEvent("LoadingManifestPrint", userProfile, {
        routesToPrint: this.routesToPrint,
      });
    }
  };

  closeDynamicRoutingFeedback = () => {
    //close dynamic routing feedback dialog and reset all related data
    this.setState({
      openDynamicRoutingFeedback: false,
      dynamicRoutingOutput: {
        affectedRoutes: [],
        lastWaveRoutes: [],
        extraTrailerRoutes: [],
      },
    });
  };

  openMenu = (event) => {
    this.setState({ menuAnchor: event.currentTarget });
  };

  closeMenu = () => {
    this.setState({ menuAnchor: null });
  };

  getNewShipmentsData = () => {
    const {
      userData: { userProfile },
    } = this.props;
    getDataWithQueryString(
      "GetShipmentsToAdd",
      `terminalId=${userProfile.terminal.id}&terminalCode=${userProfile.terminal.code}&planDate=${userProfile.planDate}&startDate=${userProfile.startDate}`
    ).then(
      (newShipments) => {
        if (newShipments?.status === 200 && newShipments?.data?.length > 0) {
          this.handleNewShipmentsNotification(
            userProfile.terminal.code,
            userProfile.planDate,
            false
          );
        }
      }
    );
  };


  toggleNotificationPanel = () => {
    this.setState((prevState) => ({
      showNotificationPanel: !prevState.showNotificationPanel,
    }),this.resetNotificationCount());
  };

  onCloseNewShipmentsFeedbackPanel = () => {
    if (this.newShipmentsDetectedKey !== null) {
      this.props.closeSnackbar(this.newShipmentsDetectedKey);
      this.newShipmentsDetectedKey = null;
    }
  };

  showNewShipmentsToastNotification = () => {
    this.props.closeSnackbar();
    if (!this.state.showAddNewShipments && !this.state.showNotificationPanel) {
      this.newShipmentsDetectedKey = this.props.enqueueSnackbar(
        "New Shipments are available",
        {
          children: (
            <NewShipmentsFeedbackPanel
              handleAddClick={this.showAddNewShipments}
              onClose={this.onCloseNewShipmentsFeedbackPanel}
            />
          ),
          autoHideDuration: appConstants.SNACKBAR_AUTO_HIDE_DURATION,
          style: { pointerEvents: "none" },
        }
      );
    }
  };

  handleNewShipmentsNotification =(
    terminalCode,
    planDate,
    showToastNotification = true
  ) => {
    const {
      userData: { userProfile },
    } = this.props;
    if (
      terminalCode === userProfile.terminal.code &&
      format(planDate, "yyyy-MM-dd") === userProfile.planDate &&
      !this.state.currentTabValue?.includes?.("reports")
    ) {
      showToastNotification && this.showNewShipmentsToastNotification();
      this.setState({
        newShipmentsUnreadCount: 1,
      });
      !this.state.showNewShipmentsNotification &&
        this.setState({
          showNewShipmentsNotification: true,
        });
    }
  };

  resetNotificationCount = () => {
    this.setState({
      newShipmentsUnreadCount : 0
    })
  }

  showAddNewShipments = () => {
      this.setState(
        {
          showAddNewShipments: true,
          showNotificationPanel: false,
        },
        () =>
          this.state.newShipmentsUnreadCount > 0 &&
          this.resetNotificationCount()
      );
      this.props.closeSnackbar();
  };

  closeAddNewShipmentsPopup = () => {
    this.setState({
      showAddNewShipments: false,
    });
  };

  render() {
    const { terminalanchorEl, moduleSwitcherAnchor, mainMenuAnchor } =
      this.state;
    const { affectedRoutes, lastWaveRoutes, extraTrailerRoutes } =
      this.state.dynamicRoutingOutput;
    const { classes } = this.props;
    const { options, activeTerminalData } = this.getTerminalMenuData();
    const dynamicRoutingFeatureFlag = this.state.featureFlags.find(
      (ele) => ele.id == "DynamicRouting"
    );
    let enableDynamicRouting = false;
    if (dynamicRoutingFeatureFlag && dynamicRoutingFeatureFlag.value) {
      enableDynamicRouting = true;
    }
    const menuProps = {
      openSettings: this.handleChange,
      shouldDialogOpen: this.shouldDialogOpen,
      isDefaultScenario: this.props.userData.userProfile.isDefaultScenario,
      terminalCode: this.props.userData.userProfile.terminal.code,
      isOptimizationRunning: this.props.CommonStore.isOptimizationRunning,
      isDataRefreshProgress: this.state.isDataRefreshProgress,
      handleTerminalClick: this.handleTerminalClick,
      width: this.props.width,
      closeMenu: this.closeMainMenu,
      selectedRouteCount:
        this.props.IBPlanningStore.selectedRouteNameList.filter(
          (routeName) => routeName !== appConstants.UNRTD_ROUTENAME
        ).length,
      enableDynamicRouting: enableDynamicRouting,
      userProfile: this.userProfileData,
    };
    const showNotificationHeaderIcon = !this.state.currentTabValue?.includes?.("reports")
    return (
      <div>
        {this.state.currentTabValue &&
          this.state.currentTabValue != this.props.path.url && (
            <Redirect to={this.state.currentTabValue} push />
          )}
        <AppBar
          position="sticky"
          className="appHeader"
          classes={{ root: classes.headerStyles }}
        >
          <Toolbar variant="dense" classes={{ gutters: classes.gutters }}>
            <div>
              <IconButton
                disableRipple={true}
                color="primary"
                onClick={this.openModuleSwitcher}
                data-automationid="hamburger-menu"
              >
                <Tooltip title="Switch Modules">
                  <i
                    className={`${classes.moduleSwitcher} icon-icon_burger_menu`}
                  />
                </Tooltip>
              </IconButton>
              <ModuleSwitcher
                menuAnchor={moduleSwitcherAnchor}
                onClose={this.onModuleSwitcherClose}
                handleModuleChange={this.handleChange}
                userProfile={this.props.userData.userProfile}
              />
            </div>
            <img
              className={classes.rmaxLogo}
              src="../../images/RouteMax_Logo_Orange_v2.svg"
            />
            <Tabs
              value={
                this.tabValues.includes(this.state.currentTabValue)
                  ? this.state.currentTabValue
                  : false
              }
              classes={{
                root: classes.tabsRoot,
                indicator: classes.tabsIndicator,
              }}
              onChange={this.handleChange}
            >
              <Tab
                value={this.tabValues[0]}
                label="Shipment Management"
                id="ShipmentManagementHeader"
                classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected,
                }}
              />
              <Tab
                value={this.tabValues[1]}
                label="Route Planning"
                id="RoutesPlanningHeader"
                classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected,
                }}
              />
              <Tab
                value={this.tabValues[2]}
                label="Customer Management"
                id="CustomerManagementHeader"
                classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected,
                }}
              />
            </Tabs>
            <div className={classes.grow}>
              <span
                className={
                  this.props.configJSON && !this.props.configJSON.isProduction
                    ? classes.wrongEnvironmentWarning
                    : classes.hideWarning
                }
                data-automationid="wrong-env-text"
              >
                <div>TEST ENVIRONMENT</div>
                <span
                  className={classes.prodLink}
                  onClick={() =>
                    window.open(this.props.configJSON.productionURL, "_self")
                  }
                >
                  Click here for Live App
                </span>
              </span>
            </div>
            <ShipmentSelectionMenu
              open={Boolean(this.state.menuAnchor)}
              menuAnchor={this.state.menuAnchor}
              onClose={this.closeMenu}
              openSettings={this.handleChange}
            />
            <div className={classes.headerIcons}>
              {this.props.configJSON?.selectShipmentURL ? (
                <ShipmentSelection
                  url={this.props.configJSON.selectShipmentURL}
                />
              ) : null}
              <div className={classes.refreshContainer}>
                <div
                  className={classes.refreshText}
                  data-automationid="plan-date"
                  onClick={this.openMenu}
                >
                  <span className={classes.planDate}>
                    Plan date:
                    {this.props.userData.userProfile.startDate
                      ? ` ${formatDate(this.props.userData.userProfile.startDate, "MM/dd")} - `
                      : " "}
                    {formatDate(
                      this.props.userData.userProfile.planDate,
                      "MM/dd"
                    )}{" "}
                  </span>
                  <span className={classes.scenarioDetail}>
                    {" "}
                    {this.props.userData.userProfile.scenarioName}{" "}
                    {`(${this.props.userData.userProfile.scenarioID})`}{" "}
                  </span>
                  {/* TODO: Keep dynamic value here Refreshed 15 min ago */}
                </div>
                <div className={classes.refreshIconContainer}>
                  <i
                    className={`${classes.refreshIcon} icon-refresh-1 ${
                      this.state.isDataRefreshProgress ? "animate-spin" : ""
                    }`}
                  ></i>
                </div>
              </div>
              {this.props.width === "xl" || this.props.width === "lg" ? (
                <RightNavigationMenu
                  {...menuProps}
                  toggleNotificationPanel={this.toggleNotificationPanel}
                  showNotificationPanel={this.state.showNotificationPanel}
                  showNewShipmentsNotification={
                    this.state.showNewShipmentsNotification
                  }
                  unreadCount={this.state.newShipmentsUnreadCount}
                  handleAddClick={this.showAddNewShipments}
                  showNotificationHeaderIcon={showNotificationHeaderIcon}
                />
              ) : (
                <Menu
                  disablePortal={true}
                  getContentAnchorEl={null}
                  disableAutoFocusItem={true}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                  open={Boolean(mainMenuAnchor)}
                  anchorEl={mainMenuAnchor}
                  onClose={this.closeMainMenu}
                  MenuListProps={{ disablePadding: true }}
                  classes={{
                    paper: classes.mainMenu,
                  }}
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  <RightNavigationMenu
                    {...menuProps}
                    toggleNotificationPanel={this.toggleNotificationPanel}
                    showNotificationPanel={this.state.showNotificationPanel}
                    showNewShipmentsNotification={
                      this.state.showNewShipmentsNotification
                    }
                    unreadCount={this.state.newShipmentsUnreadCount}
                    handleAddClick={this.showAddNewShipments}
                    showNotificationHeaderIcon={showNotificationHeaderIcon}
                  />
                </Menu>
              )}
            </div>
            <div className={classes.toggledMenu}>
              <IconButton
                color="inherit"
                className={classes.mainMenuButton}
                onClick={this.openMainMenu}
              >
                <Tooltip title="Main Menu">
                  <MoreVert style={{ fontSize: "21px" }} />
                </Tooltip>
              </IconButton>
            </div>
          </Toolbar>
          {
            //open dynamic routing feedback after dynamic routing dialog gets closed
            this.state.openDynamicRoutingFeedback && (
              <DynamicRoutingFeedback
                show={this.state.openDynamicRoutingFeedback}
                affectedRoutes={affectedRoutes}
                lastWaveRoutes={lastWaveRoutes}
                extraTrailerRoutes={extraTrailerRoutes}
                onClose={this.closeDynamicRoutingFeedback}
              />
            )
          }
          <Suspense fallback={<AppLoading />}>
            {this.state.isETLRunningForFirstPush && (
              <ETLProgressDialog
                show={this.state.isETLRunningForFirstPush}
                planDate={this.state.currentPlanDate}
                theme={this.props.userData.userProfile.theme}
              />
            )}
            {this.state.isDialogOpen &&
              this.state.title &&
              this.getDialogComponent(this.state.title)}
            {this.state.terminalanchorEl && (
              <TerminalSelect
                terminalAnchor={terminalanchorEl}
                closeTerminalmenu={this.handleTerminalClose}
                terminalOptions={options}
                handleTerminalChange={this.handleTerminalChange}
                activeTerminal={activeTerminalData}
              />
            )}
          </Suspense>
        </AppBar>
        {this.state.showAddNewShipments && (
          <AddNewShipmentsOverlay
            open
            glEventHub={this.props.glEventHub}
            userProfile={this.props.userData.userProfile}
            serviceLevelList={this.props.IBPlanningStore.serviceLevelList}
            handleCancel={this.closeAddNewShipmentsPopup}
          />
        )}
        <ParameterListener
          scenarioId={this.props.userData.userProfile.scenarioID}
        />
      </div>
    );
  }
}
export default compose(
  withWidth(),
  withTheme(),
  withStyles(styles),
  withRouter,
  withUserProfile,
  withSnackbar,
  withAppConfig
)(IbplanningHeader);
